import { render, staticRenderFns } from "./ProductorCourses.vue?vue&type=template&id=09281a52&scoped=true"
import script from "./ProductorCourses.vue?vue&type=script&lang=js"
export * from "./ProductorCourses.vue?vue&type=script&lang=js"
import style0 from "./ProductorCourses.vue?vue&type=style&index=0&id=09281a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09281a52",
  null
  
)

export default component.exports